import React, { useState } from "react";
import { sendOtp, verifyOtp, resendOtp } from "../middleware/backend_hepler";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/send-otp.png";
import rightLender from "../assets/logo.png";
import otpVerify from "../assets/otp-verify.png";
import LoanOffers from "./LoanOffer/OtpLoanOffer";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


const OTPVerification = () => {
  const [mobile, setMobile] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpDigits, setOtpDigits] = useState(["", "", "", ""]);
  const navigate = useNavigate();
  const location = useLocation();
  const loanType = location.state?.loanType;

  const handleSendOtp = async () => {
    try {
      if (!isAgreed) return;
      if (!mobile) {
        toast.error("Mobile number is required");
      }
      const response = await sendOtp({ mobile });
      if (response.status === 200 && response.data?.type === "success") {
        toast.success("OTP sent successfully!");
        setOtpSent(true);
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      // toast.error(error.response?.data?.message || error.message);
    }
  };

  const handleVerifyOtp = async () => {
    const otp = otpDigits.join("");

    try {
      if (!mobile) {
        toast.error("Mobile number is required");
      }
      if (otp.length !== 4) {
        toast.error("Please enter a 4-digit OTP")
      }

      const response = await verifyOtp({ otp, mobile });

      if (response.status === 200 && response.data.type === "success") {
        toast.success("OTP verified successfully!");  
        localStorage.setItem("verifiedMobile", mobile);

        if (loanType === "home") {
          navigate("/create-home-loan");
        } else if (loanType === "personal") {
          navigate("/create-personal-loan");
        } else if (loanType === "business") {
          navigate("/create-business-loan");
        } else if (loanType === "mortgage") {
          navigate("/create-mortgage-loan");
        } else if (loanType === "nri") {
          navigate("/create-nri-loan");
        } else if (loanType === "doctor") {
          navigate("/create-doctor-loan");
        } else {
          toast.error("Unknown loan type. Please select a valid loan type.");
        }
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (error) {
      // toast.error(error.response?.data?.message || error.message);
    }
  };

  const handleResendOtp = async () => {
    try {
      if (!mobile) {
        toast.error("Mobile number is required");
      }

      const response = await resendOtp({ mobile });

      if (response.status === 200 && response.data.type === "success") {
        toast.success("OTP resent successfully!");
      } else {
        toast.error("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
    }
  };

  const handleOtpChange = (index, value) => {
    const updatedOtp = [...otpDigits];
    updatedOtp[index] = value;
    setOtpDigits(updatedOtp);

    if (value && index < 3) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const formatLoanType = (type) => {
    if (type === "nri") return "NRI";
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  return (
    <div className="modal-overlay-ourservice">
      <div className="modal-content-ourservice">
        <div className="otp-back-row">
          <div className="otp-back-text" onClick={() => navigate(-1)}>
            &lt; Go Back
          </div>
          {/* <h2 className="otp-title">Track My Application</h2> */}
        </div>

        <div className="otp-body-sections">
          <div className="otp-section left-section">
            <LoanOffers loanType={loanType} />
          </div>
          <div className="otp-section right-section">
            {otpSent ? (
              <>
                <div className="lender-logo">
                  <img
                    src={rightLender}
                    alt="Resonance Logo"
                    className="lender-logo-image"
                  />
                </div>
                <div className="otp-input-group">
                  {otpDigits.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-input-${index}`}
                      className="otp-input"
                      type="text"
                      placeholder="*"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                    />
                  ))}
                </div>
                <div className="otp-buttons">
                  <button onClick={handleVerifyOtp} className="btn-submit">
                    Submit
                  </button>
                  <button
                    className="otp-btn-cancel"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </button>
                </div>
                <div className="otp-info-text">
                  <p className="resend-text">
                    Didn’t receive the OTP?{" "}
                    <span onClick={handleResendOtp} className="resend-link">
                      Resend
                    </span>
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="lender-logo">
                  <img
                    src={rightLender}
                    alt="Resonance Logo"
                    className="lender-logo-image"
                  />
                </div>

                <input
                  className="mobile-input"
                  type="text"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder="Enter Mobile Number"
                  maxLength={10}
                  required
                />
                <div className="agreement-box">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      className="custom-checkbox"
                      checked={isAgreed}
                      onChange={(e) => setIsAgreed(e.target.checked)}
                    />
                    <span className="highlight-color">
                      Read Our{" "}
                      <Link to="/terms-conditions">Terms & Conditions</Link> &{" "}
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </span>
                  </label>
                </div>
                <div className="btn-otp-submit">
                  <button
                    onClick={handleSendOtp}
                    className="btn-submit"
                    disabled={!isAgreed}
                  >
                    Get OTP
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="ourservice-offer-box">
          <h4>
            <span className="highlight-rate highlight-color">
              “Cibil Score is Must but Relax{" "}
            </span>
            — your CIBIL score isn’t affected when you apply with us. However,
            Banks or NBFCs will check your credit score after we match you with
            the right lender.”
          </h4>
        </div>
        <p></p>
      </div>
      <ToastContainer />
    </div>
  );
};

export default OTPVerification;
